import { render, staticRenderFns } from "./AnimatedIconDanger.vue?vue&type=template&id=5f2ea595&scoped=true&"
import script from "./AnimatedIconDanger.vue?vue&type=script&lang=js&"
export * from "./AnimatedIconDanger.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIconDanger.vue?vue&type=style&index=0&id=5f2ea595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ea595",
  null
  
)

export default component.exports